if (!customElements.get('ps-theme-card')) {
  customElements.define('ps-theme-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-version-select]')) return;
        let active;
        this.querySelectorAll('[data-version-panel]').forEach(panel => {
          panel.hidden = panel.dataset.versionPanel !== event.target.value;
          if (!panel.hidden) active = panel;
        });
        if (active) this.setPhoto(active.dataset.productImage, active.dataset.imageAlt);
      });
      this.addEventListener('ps:variant-change', event => {
        if (event.detail.image) this.setPhoto(event.detail.image, event.detail.title);
      });
    }
    setPhoto(url, alt) {
      const photo = this.querySelector('.pw-card-image img');
      photo.src = url;
      photo.removeAttribute('srcset');
      photo.alt = alt;
    }
  });
}
